import { addHeader, addHeaderWithOutBody } from "./headers";
import constants from "./api_urls";
import { getclusterbyDomain } from "../services/white_label";
import { refreshTokenEventEmitter } from "./sessionEvents";

//i want to get user data from the local storage using the key "user"
export function getUser() {
  return JSON.parse(localStorage.getItem("user"));
}

export async function apiGet(path) {
  try {
    const response = await fetch(
      constants.mainUrl + path,
      await addHeaderWithOutBody("GET")
    );
    console.log(response);
    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    console.error("Fetch error:", error);
    return { body: null, status: 500, error: error.message };
  }
}

export async function apiGetPublic(path) {
  try {
    const response = await fetch(
      constants.mainUrlPublic + path,
      await addHeaderWithOutBody("GET")
    );
    console.log(response);
    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    console.error("Fetch error:", error);
    return { body: null, status: 500, error: error.message };
  }
}

export async function apiGetOpenSource(uriPath) {
  try {
    const response = await fetch(uriPath, await addHeaderWithOutBody("GET"));
    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    const status = error?.response?.status || 500;
    return { body: null, status, error: error?.message };
  }
}

export async function apiDelete(path) {
  try {
    const response = await fetch(
      constants.mainUrl + path + `?editedBy=${getUser()?._id}`, // if your delete method requires a body
      await addHeaderWithOutBody("DELETE")
    );
    console.log(response);
    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    const status = error?.response?.status || 500;
    return { body: null, status, error: error?.message };
  }
}
export async function apiDeleteWithBody(body, path) {
  const uri = constants.mainUrl + path;
  try {
    const response = await fetch(uri, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...(await addHeaderWithOutBody("DELETE")), // if your header method adds other required headers
      },
      body: JSON.stringify(body),
      credentials: "include",
    });

    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    const status = error?.response?.status || 500;
    return { body: null, status, error: error?.message };
  }
}

export async function apiPostPut(body, path, method) {
  const uri = constants.mainUrl + path;
  console.log("oldBody", body);

  let newBody = body;
  if (method === "POST") {
    newBody = {
      ...newBody,
      addedBy: getUser()?._id,
      cluster: getclusterbyDomain(),
    };
  } else {
    newBody = {
      ...newBody,
      editedBy: getUser()?._id,
    };
  }
  console.log("newBody", newBody);

  try {
    const response = await fetch(uri, await addHeader(newBody, method));
    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    const status = error?.response?.status || 500;
    return { body: null, status, error: error?.message };
  }
}

export async function apiPostPutPublic(body, path, method) {
  const uri = constants.mainUrlPublic + path;
  console.log("oldBody", body);

  let newBody = body;
  if (method === "POST") {
    newBody = {
      ...newBody,
      cluster: getclusterbyDomain(),
    };
  }
  console.log("newBody", newBody);
  try {
    const response = await fetch(uri, await addHeader(newBody, method));
    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    const status = error?.response?.status || 500;
    // console.log("error", error?.response?.data);
    return { body: {title: error?.response?.data?.title, message: error?.response?.data?.message}, status, error: error?.message };
  }
}

export async function apiPostPutWithoutUrl(body, path, method) {
  const uri = path;

  let newBody = body;

  try {
    const response = await fetch(uri, await addHeader(newBody, method));
    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    const status = error?.response?.status || 500;
    return { body: null, status, error: error?.message };
  }
}


export async function logout() {
  try {
    const response = await fetch(
      constants.mainUrl + "/user/logout",
      await addHeaderWithOutBody("POST")
    );
    const data = await handleResponse(response);
    return { body: data, status: response.status };
  } catch (error) {
    const status = error?.response?.status || 500;
    return { body: null, status, error: error?.message };
  }
}


async function handleResponse(response) {
  let data = null;
  try {
    data = await response?.json();
  } catch (e) {
    // non-JSON or empty responses
    data = null;
  }

  if (!response.ok) {
    const message = data?.message || "Request failed";
    if (
      response.status === 401 &&
      typeof message === "string" &&
      message.includes("Refresh token")
    ) {
      try {
        refreshTokenEventEmitter.dispatchEvent(
          new CustomEvent("show-refresh-token-popup", {
            detail: { message, status: response.status },
          })
        );
      } catch (e) {
        // no-op if emitter not available
      }
    }

    const error = new Error(`${message}`);
    error.response = { status: response.status, data };
    throw error;
  }

  return data;
}